import IProduct, { ICalorie } from '@/interfaces/product';
import { toUpperCase } from '@/helpers/toUpperCase';

export default class ProductModel {
  public id: string;
  public descricao: string;
  public codigo: string;
  public subgrupo: any;
  public insumos: any[];
  public coloracao: string;
  public visibilidade: string;
  public concentracao: number;
  public osmolaridade: number;
  public densidade: number;
  public kcalGrama: number;
  public grama: number;
  public mmol: number;
  public meq: number;
  public ui: number;
  public unidades: any[];
  public disponibilizarNaPrescricao: boolean;
  public divisivelBolsas: boolean;
  public usoPacienteAdulto: boolean;
  public usoPacienteNeonato: boolean;
  public usoPacientePediatrico: boolean;
  public urlEducativo: string;
  public ativo: boolean;
  public isAgua: boolean;
  public caloria: ICalorie;
  public empresa: number;
  public permiteAltAutomatica: boolean;
  public isChangeable: boolean;
  public permitePesoCalorico: boolean;

  constructor(initialValues?: IProduct) {
    this.id = !!initialValues && initialValues.id ? initialValues.id : null;
    this.descricao =
      !!initialValues && initialValues.descricao ? initialValues.descricao : '';
    this.codigo =
      !!initialValues && initialValues.codigo ? initialValues.codigo : '';
    this.coloracao =
      !!initialValues && initialValues.coloracao ? initialValues.coloracao : '';
    this.visibilidade =
      !!initialValues && initialValues.visibilidade
        ? initialValues.visibilidade
        : '';
    this.subgrupo =
      !!initialValues && initialValues.subgrupo ? initialValues.subgrupo : null;
    this.insumos =
      !!initialValues && initialValues.insumos ? initialValues.insumos : [];
    this.unidades =
      !!initialValues && initialValues.unidades ? initialValues.unidades : [];
    this.disponibilizarNaPrescricao =
      !!initialValues &&
      typeof initialValues.disponibilizarNaPrescricao !== 'undefined'
        ? initialValues.disponibilizarNaPrescricao
        : true;
    this.divisivelBolsas =
      !!initialValues && typeof initialValues.divisivelBolsas !== 'undefined'
        ? initialValues.divisivelBolsas
        : true;
    this.concentracao =
      !!initialValues && initialValues.concentracao
        ? initialValues.concentracao
        : 0;
    this.osmolaridade =
      !!initialValues && initialValues.osmolaridade
        ? initialValues.osmolaridade
        : 0;
    this.densidade =
      !!initialValues && initialValues.densidade ? initialValues.densidade : 0;
    this.kcalGrama =
      !!initialValues && initialValues.kcalGrama ? initialValues.kcalGrama : 0;
    this.grama =
      !!initialValues && initialValues.grama ? initialValues.grama : 0;
    this.mmol = !!initialValues && initialValues.mmol ? initialValues.mmol : 0;
    this.meq = !!initialValues && initialValues.meq ? initialValues.meq : 0;
    this.ui = !!initialValues && initialValues.ui ? initialValues.ui : 0;
    this.caloria =
      !!initialValues && initialValues.caloria ? initialValues.caloria : null;
    this.usoPacienteAdulto = !!initialValues
      ? initialValues.usoPacienteAdulto
      : false;
    this.usoPacienteNeonato = !!initialValues
      ? initialValues.usoPacienteNeonato
      : false;
    this.usoPacientePediatrico = !!initialValues
      ? initialValues.usoPacientePediatrico
      : false;
    this.ativo =
      !!initialValues && typeof initialValues.ativo !== 'undefined'
        ? initialValues.ativo
        : true;
    this.isAgua =
      !!initialValues && typeof initialValues.isAgua !== 'undefined'
        ? initialValues.isAgua
        : false;
        this.permiteAltAutomatica =
        !!initialValues &&
        typeof initialValues.permiteAltAutomatica !== 'undefined'
        ? initialValues.permiteAltAutomatica
        : true;
        this.urlEducativo =
        !!initialValues && initialValues.urlEducativo
        ? initialValues.urlEducativo
        : null;
    this.isChangeable =
      !!initialValues && typeof initialValues.isChangeable !== 'undefined'
        ? initialValues.isChangeable
        : false;
    this.permitePesoCalorico = initialValues? initialValues.permitePesoCalorico : null;
  }

  public validate(): boolean {
    return (
      !!this.descricao &&
      !!this.descricao &&
      !!this.subgrupo &&
      !!this.insumos.length &&
      !!this.unidades.length
    );
  }

  public toJson(): IProduct {
    const unidades = this.unidades.map((item) => {
      return {
        id: item.id,
      };
    });

    const jsonInsumos = this.insumos.map((item) => {
      return {
        insumo: { id: item.insumo.id },
        quantidade: item.quantidade,
        quantidadeReferencia: item.quantidadeReferencia
      };
    });

    return {
      id: this.id,
      descricao: this.descricao,
      codigo: toUpperCase(this.codigo),
      subgrupo: this.subgrupo,
      insumos: jsonInsumos,
      coloracao: this.coloracao,
      visibilidade: this.visibilidade,
      concentracao: this.concentracao || 0,
      osmolaridade: this.osmolaridade || 0,
      densidade: this.densidade || 0,
      kcalGrama: this.kcalGrama || 0,
      grama: this.grama || 0,
      mmol: this.mmol || 0,
      meq: this.meq || 0,
      ui: this.ui || 0,
      caloria: this.caloria,
      unidades,
      disponibilizarNaPrescricao: this.disponibilizarNaPrescricao,
      divisivelBolsas: this.divisivelBolsas,
      usoPacienteAdulto: this.usoPacienteAdulto,
      usoPacienteNeonato: this.usoPacienteNeonato,
      usoPacientePediatrico: this.usoPacientePediatrico,
      urlEducativo: this.urlEducativo,
      ativo: this.ativo,
      empresa: this.empresa,
      permiteAltAutomatica: this.permiteAltAutomatica,
      permitePesoCalorico: this.permitePesoCalorico,
    };
  }
}
